module.exports = __webpack_public_path__ + "static/media/no-wrkspace.8c11e5e4.svg";